/* eslint arrow-body-style: ["error", "always"] */
/**
 * Adds an react element as direct child of <body></body>
 */

import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';

export default class AddToBody extends Component {
    componentDidMount() {
        this.element = document.createElement('div');
        document.body.appendChild(this.element);
        this._renderLayer();
    }

    componentDidUpdate() {
        this._renderLayer();
    }

    componentWillUnmount() {
        ReactDOM.unmountComponentAtNode(this.element);
        document.body.removeChild(this.element);
    }

    _renderLayer() {
        ReactDOM.render(this.props.children, this.element);
    }

    render() {
        // Render a placeholder
        return React.DOM.div(this.props);
    }
}

AddToBody.propTypes = {
    children: PropTypes.element
};



// WEBPACK FOOTER //
// ./src/components/helpers/AddToBody.js